import { getDelta } from '@/js/countdown-timer-actions.js';

/**
 * When the user selects the checkbox to confirm that they understand that this product can only be shipped to Kyoto, this function will enable the add to cart button.
 * @param {ProductAddCTA} productAddCtaElement - the productAddCtaElement custom element
 * @return {void}
 */

const confirmKyotoOnlyShipment = productAddCtaElement => {
  document.addEventListener('pxl:productCheckboxChange', event => {
    if (!event.detail) {
      return;
    }

    const button = productAddCtaElement.button;
    const launchDate = button.dataset.launchDate;
    const delta = getDelta(launchDate);
    const launchDateDoesNotPreventAddToCart =
      delta <= 0 || Number.isNaN(Number(delta));

    // Check if product is sold out (max-inventory-quantity is 0)
    const maxInventoryQuantity = button.getAttribute('max-inventory-quantity');
    const isSoldOut =
      maxInventoryQuantity && Number.parseInt(maxInventoryQuantity) === 0;

    // If sold out, don't change the button state - keep it disabled
    if (isSoldOut) {
      return;
    }

    if (event.detail.selected && launchDateDoesNotPreventAddToCart) {
      productAddCtaElement.enableButton();
    } else {
      productAddCtaElement.disableButton();
    }
  });
};

/**
 *  If the product is only available for shipment to Kyoto, this function will disable the add to cart button and add an event listener to the checkbox to confirm that the user understands that this product can only be shipped to Kyoto.
 * @param {ProductAddCTA} productAddCtaElement - the productAddCtaElement custom element
 * @returns {void}
 */
const initKyotoOnlyProduct = productAddCtaElement => {
  if (productAddCtaElement.button.hasAttribute('kyoto-only-product')) {
    confirmKyotoOnlyShipment(productAddCtaElement);
  }
};

export { initKyotoOnlyProduct };
